// import { emptySplitApi } from "./InjectionEndpoint";

// const authApi = emptySplitApi.injectEndpoints({
//   endpoints: (build) => ({
//     login: build.mutation({
//       query: (data) => ({
//         url: '/api/auth/login',
//         method: 'POST',
//         body: data,
//       }),
//     }),

//     getQrCode: build.query<string, { token: string }>({
//       query: ({ token }) => ({
//         url: "/api/Auth/2fa/qrcode",
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }),
//     }),    

//     verifyOtp: build.mutation({
//       query: ({ otp, token }) => ({
//         url: '/api/auth/2fa/validate', // <-- assicurati che sia l'endpoint corretto
//         method: 'POST',
//         headers: {
//           Authorization: `Bearer ${token}`, // passi il JWT ricevuto alla login
//         },
//         body: {
//           otp,
//         },
//       }),
//     }),
//   }),
// });

// export const {
//   useLoginMutation,
//   useVerifyOtpMutation,
//   useGetQrCodeQuery,
// } = authApi;


import { emptySplitApi } from "./InjectionEndpoint";

const authApi = emptySplitApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (data) => ({
        url: '/api/auth/login',
        method: 'POST',
        body: data,
      }),
    }),
    fetchQrCode: build.query<Blob, { twoFactorToken: string }>({
      query: ({ twoFactorToken }) => ({
        url: `/api/Auth/2fa/qrcode?twoFactorToken=${encodeURIComponent(twoFactorToken)}`,
        method: 'GET',
        responseHandler: (response: any) => response.blob(),
      }),
    }),       
    validateOtp: build.mutation({
      query: ({ code, token }) => ({
        url: '/api/Auth/2fa/validate',
        method: 'POST',
        body: { code, token },
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useFetchQrCodeQuery,
  useValidateOtpMutation
} = authApi;